import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { WATCH_LIST_DEACTIVATION } from "../types";
import {
  watchListDeactivationFulfilled,
  watchListDeactivationRejected,
  watchListDeactivationPending,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "delete",
  url: "watchlist/Delete/" + payload.watchListId,
  onSuccess: [
    (response) => (// eslint-disable-next-line
      watchListDeactivationFulfilled(response), window.location.reload()
    ),
  ],
  onError: [
    watchListDeactivationRejected,
    (error) => notifyError(generateError(error)),
  ],
});

const meta = {
  api: "ajaxApi",
};

const watchListDeactivationEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(WATCH_LIST_DEACTIVATION.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(watchListDeactivationPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default watchListDeactivationEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/watchListDeactivationEpic.js